import { render, staticRenderFns } from "./StatsB2C2B.vue?vue&type=template&id=6da4950b"
import script from "./StatsB2C2B.vue?vue&type=script&lang=js"
export * from "./StatsB2C2B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports